export const checkbox0 = "M12,1c1.65685,0 3,1.34315 3,3v8c0,1.65685 -1.34315,3 -3,3h-8c-1.65685,0 -3,-1.34315 -3,-3v-8c0,-1.65685 1.34315,-3 3,-3z"

export const checkbox1 = "M11,7c0.55228,0 1,0.44772 1,1c0,0.55228 -0.44772,1 -1,1h-6c-0.55228,0 -1,-0.44772 -1,-1c0,-0.55228 0.44772,-1 1,-1z"

export const checkbox2 = "M3.992,8.033l0.5,-0.531c0.06437,-0.06984 0.15502,-0.10957 0.25,-0.10957c0.09498,0 0.18563,0.03973 0.25,0.10957l1.725,1.86l3.846,-4.141c0.06437,-0.06984 0.15502,-0.10957 0.25,-0.10957c0.09498,0 0.18563,0.03973 0.25,0.10957l0.5,0.532c0.13752,0.1499 0.13752,0.3801 0,0.53l-4.596,4.94c-0.06437,0.06984 -0.15502,0.10957 -0.25,0.10957c-0.09498,0 -0.18563,-0.03973 -0.25,-0.10957l-2.475,-2.658c-0.13779,-0.15057 -0.13779,-0.38143 0,-0.532z"

export const downChevron = "M13,6.175l-5,5l-5,-5l1.175,-1.175l3.825,3.81667l3.825,-3.81667z"

export const leftChevron = "M7.35833,8l3.81667,3.825l-1.175,1.175l-5,-5l5,-5l1.175,1.175z"

export const radio0 = "M15,8c0,3.864 -3.136,7 -7,7c-3.864,0 -7,-3.136 -7,-7c0,-3.864 3.136,-7 7,-7c3.864,0 7,3.136 7,7z"

export const radio1 = "M11,8c0,1.656 -1.344,3 -3,3c-1.656,0 -3,-1.344 -3,-3c0,-1.656 1.344,-3 3,-3c1.656,0 3,1.344 3,3z"

export const rightChevron = "M11.175,8l-5,5l-1.175,-1.175l3.81667,-3.825l-3.81667,-3.825l1.175,-1.175z"

export const upChevron = "M13,10l-1.175,1.175l-3.825,-3.81667l-3.825,3.81667l-1.175,-1.175l5,-5z"